import type { MainLineSettings, BackgroundSettings, FibonacciSettings } from "./types";

export const DEFAULT_MAIN_LINE: MainLineSettings = {
  color: "#22c55e",
  width: 1,
  opacity: 100,
};

export const DEFAULT_BACKGROUND: BackgroundSettings = {
  color: "#22c55e",
  opacity: 20,
};

export const DEFAULT_FIBONACCI: FibonacciSettings = {
  levelDisplay: "values",
  levelsColor: "#ffffff",
  levelsVisible: true,
  valuesColor: "#22c55e",
  valuesVisible: true,
};
